var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"},style:({height:_vm.innerHeight+'px'})},[_c('ExamHeader'),_c('div',{staticClass:"content",style:({height:`${_vm.innerHeight- 56}px`})},[_c('LeftPanel'),_c('RightPanel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }